<script setup lang="ts">
const checked = defineModel<boolean>({ required: true });

const props = withDefaults(
  defineProps<{
    inputId?: string;
    cguTo?: string;
    errorMessage?: string | null;
    openCgu?: () => void;
  }>(),
  {
    inputId: "approval-checkbox",
    cguTo: "/cgu",
    errorMessage: null,
  }
);

const errorId = computed(() => `${props.inputId}-error`);
const hasError = computed(() => !!props.errorMessage);

// Plateforme : si `openCgu` est fourni (mobile), on intercepte le clic vers la page CMS native
// plutôt que de suivre le lien — un `<a target="_blank">` ne navigue pas dans Capacitor. Web :
// prop absente, le ULink suit `cguTo` normalement.
function onCguClick(event: MouseEvent) {
  if (!props.openCgu) return;
  event.preventDefault();
  props.openCgu();
}
</script>

<template>
  <div class="w-full">
    <label :for="inputId" class="flex items-start gap-2 text-sm leading-snug cursor-pointer">
      <input
        :id="inputId"
        v-model="checked"
        type="checkbox"
        class="shrink-0 mt-0.5 size-4 cursor-pointer accent-primary"
        :aria-invalid="hasError ? 'true' : undefined"
        :aria-describedby="hasError ? errorId : undefined"
      />
      <i18n-t keypath="app.approval" tag="span" scope="global" class="inline pt-px">
        <ULink :to="cguTo" target="_blank" @click="onCguClick">
          {{ $t("app.approval.conditions") }}
        </ULink>
      </i18n-t>
    </label>
    <p v-if="errorMessage" :id="errorId" class="mt-1 text-sm/tight text-error" role="alert">
      {{ errorMessage }}
    </p>
  </div>
</template>
